<div class="">
  <div>
    <div class="d-flex flex-column w-100 align-items-center mt-4">
      <b style="font-size: 18px"> Add New Vendor to</b>
      <span style="font-size: 18px">{{ companyName }}</span>
    </div>
    <div class="card-body">
      <form name="userNewForm" #userNewForm="ngForm">
        <mat-stepper>
          <mat-step label="User Information">
            <!-- <div *ngIf="data.company" class="form-group">
              <label class="bmd-label-floating">Company Name</label>
              <input
                type="text"
                class="form-control"
                name="companyname"
                #companyname="ngModel"
                [(ngModel)]="companyName"
                disabled
              />
            </div> -->
            <div *ngIf="!data.company" class="form-group">
              <app-filter
                type="COMPANY"
                (select)="changeCompany($event)"
              ></app-filter>

              <button (click)="openNuevoCompany()" class="gts-btn-primary">
                <span class="gts-btn-icon-left"> note_add </span>
                <span class="gts-btn-text"> New Company </span>
              </button>
            </div>

            <mat-form-field>
              <mat-label>Title</mat-label>
              <input
                type="text"
                matInput
                #name="ngModel"
                [(ngModel)]="data.user.ocupation"
              />
            </mat-form-field>

            <!-- <div class="form-group">
            <label class="bmd-label-floating">Title</label>
            <input
              type="text"
              class="form-control"
              name="ocupation"
              #ocupation="ngModel"
              [(ngModel)]="data.user.ocupation"
            />
          </div> -->

            <div class="grid-container">
              <mat-form-field>
                <mat-label>First Name</mat-label>
                <input
                  type="text"
                  matInput
                  name="name"
                  [(ngModel)]="data.user.name"
                  required
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Last Name</mat-label>
                <input
                  type="text"
                  matInput
                  name="surname"
                  [(ngModel)]="data.user.surname"
                  required
                />
              </mat-form-field>
              <mat-form-field>
                <mat-label>email</mat-label>
                <input
                  required
                  matInput
                  type="email"
                  name="correo"
                  #correo="ngModel"
                  [(ngModel)]="data.user.email"
                />
              </mat-form-field>
              <!-- <label
              class="font-italic"
              *ngIf="correo.touched && !mtds.emailValid(data.user.email)"
            >
              Invalid Mail
            </label> -->
              <mat-form-field>
                <mat-label class="bmd-label-floating">Gender</mat-label>

                <mat-select
                  name="gender"
                  #gender="ngModel"
                  [(ngModel)]="data.user.gender"
                  placeholder="Gender"
                >
                  <mat-option *ngFor="let sexo of sexos" [value]="sexo.value">
                    {{ sexo.viewValue }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <button
              [disabled]="isDisabledFirstStep"
              class="gts-btn-primary-outline"
              matRipple
              type="button"
              matStepperNext
            >
              <span class="gts-btn-icon-left">east</span
              ><span class="gts-btn-text">Next</span>
            </button>
          </mat-step>
          <mat-step label="Address Information">
            <div class="grid-container grid-container-3">
              <mat-form-field>
                <mat-label>Saved Addresses </mat-label>
                <select
                  matNativeControl
                  name="userlocation"
                  [(ngModel)]="data.user.locationId"
                  (change)="changeLocation()"
                >
                  <option [value]="null">Headquarter's Address</option>
                  <!-- <option [value]="0">Blank - Client Address</option> -->
                  <option *ngFor="let loc of companyLocations" [value]="loc.id">
                    {{ loc.name }}
                  </option>
                </select>
              </mat-form-field>

              <mat-form-field>
                <mat-label>Address Line #</mat-label>
                <input
                  required
                  type="text"
                  name="address"
                  #address="ngModel"
                  [(ngModel)]="data.user.address"
                  [disabled]="data.user.locationId != 0"
                  matInput
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Address Line 2 #</mat-label>
                <input
                  matInput
                  type="text"
                  name="address2"
                  #address2="ngModel"
                  [(ngModel)]="data.user.address2"
                  [disabled]="data.user.locationId != 0"
                />
              </mat-form-field>

              <mat-form-field
                class="w-100"
                *ngIf="!loadingCountries && countries"
              >
                <mat-label>Country</mat-label>
                <input
                  type="text"
                  matInput
                  [matAutocomplete]="autoCountries"
                  [formControl]="myControlCountries"
                />
                <mat-autocomplete
                  #autoCountries="matAutocomplete"
                  [displayWith]="displayCountry"
                  (optionSelected)="onCountrySelected($event.option.value)"
                >
                  <mat-option
                    *ngFor="let country of filteredCountries | async"
                    [value]="country"
                  >
                    {{ country.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <!-- <mat-form-field>
                <mat-label>Country</mat-label>
                <input
                  matInput
                  type="text"
                  name="country"
                  #country="ngModel"
                  [(ngModel)]="data.user.country"
                  [disabled]="data.user.locationId != 0"
                  required
                />
              </mat-form-field> -->

              <!-- <mat-form-field>
                <mat-label>State</mat-label>
                <input
                  required
                  matInput
                  type="text"
                  name="colonia"
                  #colonia="ngModel"
                  [(ngModel)]="data.user.colonia"
                  [disabled]="data.user.locationId != 0"
                />
              </mat-form-field> -->

              <mat-form-field *ngIf="states.length === 0">
                <mat-label class="bmd-label-floating"
                  >State
                  <i
                    *ngIf="loadingStates"
                    class="fa fa-circle-o-notch fa-spin fa-fw"
                  ></i
                ></mat-label>
                <input
                  [disabled]="data.user.locationId != 0"
                  matInput
                  type="text"
                  name="colonia"
                  [(ngModel)]="data.user.colonia"
                  required
                />
              </mat-form-field>

              <mat-form-field class="mr-3" *ngIf="states.length !== 0">
                <mat-label>
                  State
                  <i
                    *ngIf="loadingStates"
                    class="fa fa-circle-o-notch fa-spin fa-fw"
                  ></i>
                </mat-label>

                <input
                  type="text"
                  matInput
                  [formControl]="myControlStates"
                  [matAutocomplete]="auto"
                  required
                />

                <mat-autocomplete
                  #auto="matAutocomplete"
                  (optionSelected)="onStateSelected($event.option.value)"
                  [displayWith]="displayState"
                >
                  <mat-option
                    *ngFor="let state of filteredStates | async"
                    [value]="state"
                  >
                    {{ state.abbr }} - {{ state.name }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field>
                <mat-label>City</mat-label>
                <input
                  required
                  matInput
                  type="text"
                  name="city"
                  #city="ngModel"
                  [(ngModel)]="data.user.city"
                  [disabled]="data.user.locationId != 0"
                />
              </mat-form-field>
              <mat-form-field class="form-group">
                <mat-label>Zip Code</mat-label>
                <input
                  required
                  matInput
                  type="text"
                  name="zipCode"
                  #zipCode="ngModel"
                  [(ngModel)]="data.user.zipCode"
                  [disabled]="data.user.locationId != 0"
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Work Phone</mat-label>
                <input
                  matInput
                  type="text"
                  class="form-control"
                  name="phone"
                  #phone="ngModel"
                  [(ngModel)]="data.user.phone"
                />
              </mat-form-field>

              <mat-form-field>
                <mat-label>Mobile Phone</mat-label>
                <input
                  matInput
                  type="text"
                  name="mobilePhone"
                  #mobilePhone="ngModel"
                  [(ngModel)]="data.user.mobilePhone"
                />
              </mat-form-field>
            </div>
            <div class="d-flex">
              <button
                class="gts-btn-primary-outline mr-2"
                matRipple
                matStepperPrevious
                type="button"
              >
                <span class="gts-btn-icon-left">west</span
                ><span class="gts-btn-text">Previous</span>
              </button>
              <button
                [disabled]="isDisabledSecondStep"
                class="gts-btn-primary-outline"
                matRipple
                matStepperNext
                type="button"
              >
                <span class="gts-btn-icon-left">east</span
                ><span class="gts-btn-text">Next</span>
              </button>
            </div>
          </mat-step>
          <mat-step label="Settings">
            <mat-form-field>
              <mat-label>Email Frequency</mat-label>
              <mat-select
                id="companyform"
                name="frequency"
                #frequency="ngModel"
                [(ngModel)]="data.user.emailFrequency"
                required
              >
                <mat-option
                  *ngFor="let frequency of frequencies"
                  [value]="frequency.value"
                >
                  {{ frequency.viewValue }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field>
              <mat-label>Password</mat-label>
              <input
                matInput
                type="password"
                name="password"
                #password="ngModel"
                [(ngModel)]="data.user.password"
                required
              />
            </mat-form-field>

            <label *ngIf="loadingReps"
              >Loading Rep List
              <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
            ></label>

            <app-filter-object
              *ngIf="!loadingReps"
              [options]="repsList"
              placeholder="Choose Rep"
              [value]="data.user.user_id"
              (selectChange)="data.user.user_id = $event.id"
            >
            </app-filter-object>
            <div class="d-flex">
              <button
                class="gts-btn-primary-outline mr-2"
                matRipple
                matStepperPrevious
              >
                <span class="gts-btn-icon-left">west</span
                ><span class="gts-btn-text">Previous</span>
              </button>
              <button
                [disabled]="!userNewForm.valid || data.user.password == ''"
                class="gts-btn-primary"
                type="submit"
                (click)="onSubmit()"
              >
                <span class="gts-btn-text"> Save </span>
              </button>
            </div>
          </mat-step>
        </mat-stepper>
      </form>
    </div>
  </div>
</div>
